var collapsible_list_pair_rtlignore_default = {
  "container": "i-sNR",
  "title": "dlwxF",
  "viewerContainer": "faGjt",
  "titleContainer": "BeSDY",
  "content": "_1Cnaq",
  "expandIcon": "q6Qdl",
  "dndIcon": "aCMib",
  "RTL": "Rf2G2",
  "LTR": "o-s4W",
  "itemContainer": "kCxnZ",
  "itemContainerViewer": "xzNTb",
  "mouseDown": "_1fqeb",
  "innerEditor": "_5mpBq",
  "item": "tdL2q",
  "floatingAddPluginMenuWrapper": "fD786"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
